import React from "react";

const Select = React.forwardRef(function Select(
  { className = "", children, ...props },
  ref,
) {
  const classes = [
    "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 shadow-sm focus:border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <select ref={ref} className={classes} {...props}>
      {children}
    </select>
  );
});

export default Select;
